import cn from "classnames";

import styles from "./day-picker.module.scss";

const DAYS = [
  { short: "S", full: "Sunday" },
  { short: "M", full: "Monday" },
  { short: "T", full: "Tuesday" },
  { short: "W", full: "Wednesday" },
  { short: "T", full: "Thursday" },
  { short: "F", full: "Friday" },
  { short: "S", full: "Saturday" },
];

interface DayPickerProps {
  value: number[];
  onChange: (days: number[]) => void;
}

export function DayPicker({ value, onChange }: DayPickerProps) {
  const toggle = (day: number) => {
    if (value.includes(day)) {
      if (value.length > 1) {
        onChange(value.filter((d) => d !== day));
      }
    } else {
      onChange([...value, day].sort((a, b) => a - b));
    }
  };

  return (
    <div className={styles.row} role="group" aria-label="Days of the week">
      {DAYS.map((day, i) => (
        <button
          key={i}
          type="button"
          className={cn(styles.day, value.includes(i) && styles.active)}
          onClick={() => toggle(i)}
          aria-label={day.full}
          aria-pressed={value.includes(i)}
        >
          {day.short}
        </button>
      ))}
    </div>
  );
}
